import { ETSY, SHOPIFY } from './channels';
import { VELA } from '.';
import ATTRIBUTE from './attributes';

export const ALL = 'all';

export const COMBINATIONS = 'combinations';

export const DELETED = 'deleted';

export const INFLUENCE = 'influence';

export const INVALID = 'invalid';

export const RETAIN = 'retain';

export const VARIANTS = 'variants';

export const VARIATIONS_TYPE = {
  BULK_CONTROLS: 'bulk-controls',
  BULK_INDIVIDUAL: 'bulk-individual',
  SINGLE: 'single',
  PROFILES: 'profiles',
};

export const MAXIMUM_OPTIONS_TO_SHOW = 4;

export const THUMBNAIL_SIZE = 42;

export const NO_VARIANT = [
  'No first variation',
  'No second variation',
  'No third variation',
];

export const NUMBER_OF_VARIANTS = {
  [ETSY]: 2,
  [SHOPIFY]: 3,
  [VELA]: 3,
};

export const CHANNEL_VARIANTS = {
  [ETSY]: [...Array(NUMBER_OF_VARIANTS[ETSY]).keys()],
  [SHOPIFY]: [...Array(NUMBER_OF_VARIANTS[SHOPIFY]).keys()],
  [VELA]: [...Array(NUMBER_OF_VARIANTS[SHOPIFY]).keys()],
};

export const TAB = {
  BARCODE: 'Barcode',
  PRICE: 'Price',
  QUANTITY: 'Quantity',
  PHOTOS: 'Photos',
  SHIPPING: 'Shipping',
  SKU: 'SKU',
  VARIATIONS: 'Variations',
  VISIBILITY: 'Visibility',
};

export const TAB_TO_ATTRIBUTE = {
  [TAB.BARCODE]: ATTRIBUTE.BARCODE,
  [TAB.PRICE]: ATTRIBUTE.PRICE,
  [TAB.QUANTITY]: ATTRIBUTE.QUANTITY,
  [TAB.PHOTOS]: ATTRIBUTE.PHOTOS,
  [TAB.SHIPPING]: ATTRIBUTE.SHIPPING,
  [TAB.SKU]: ATTRIBUTE.SKU,
  [TAB.VARIATIONS]: ATTRIBUTE.VARIATIONS,
  [TAB.VISIBILITY]: ATTRIBUTE.VISIBILITY,
};

export const TAB_VALUES = {
  [ETSY]: {
    [TAB.PRICE]: [ATTRIBUTE.PRICE],
    [TAB.QUANTITY]: [ATTRIBUTE.QUANTITY],
    [TAB.SKU]: [ATTRIBUTE.SKU],
  },
  [SHOPIFY]: {
    [TAB.BARCODE]: [ATTRIBUTE.BARCODE],
    [TAB.PRICE]: [ATTRIBUTE.CHARGE_TAX, ATTRIBUTE.PRICE, ATTRIBUTE.CAP, ATTRIBUTE.CPI],
    [TAB.QUANTITY]: [ATTRIBUTE.CONTINUE_SELLING, ATTRIBUTE.TRACK_QUANTITY, ATTRIBUTE.QUANTITY],
    [TAB.SKU]: [ATTRIBUTE.SKU],
    [TAB.SHIPPING]: [ATTRIBUTE.PHYSICAL, ATTRIBUTE.WEIGHT, ATTRIBUTE.COUNTRY_CODE, ATTRIBUTE.HS_CODE],
    [TAB.VISIBILITY]: [DELETED],
  },
  [VELA]: {
    [TAB.PRICE]: [ATTRIBUTE.PRICE],
    [TAB.QUANTITY]: [ATTRIBUTE.QUANTITY],
    [TAB.SKU]: [ATTRIBUTE.SKU],
  },
};

export const INFLUENCE_ATTRIBUTES = {
  [ETSY]: [
    ATTRIBUTE.PRICE,
    ATTRIBUTE.QUANTITY,
    ATTRIBUTE.SKU,
  ],
};

export const INFLUENCE_CONTROLS = {
  [ETSY]: {
    [TAB.PRICE]: true,
    [TAB.QUANTITY]: true,
    [TAB.SKU]: true,
  },
};

export const INFLUENCE_CONTROLS_LABEL = {
  [TAB.PRICE]: 'Individual price',
  [TAB.QUANTITY]: 'Individual quantity',
  [TAB.SKU]: 'Individual SKU',
};

export const VALIDATIONS = {
  COMBINATIONS: {
    MAXIMUM_NUMBER: {
      [ETSY]: 400,
      [SHOPIFY]: 100,
    },
  },
  OPTIONS: {
    MAXIMUM_NAME_LENGTH: {
      [ETSY]: 255,
      [SHOPIFY]: 255,
    },
    MAXIMUM_NUMBER: {
      [ETSY]: 70,
      [SHOPIFY]: 100,
    },
  },
  VARIANTS: {
    MAXIMUM_NAME_LENGTH: {
      [ETSY]: 45,
      [SHOPIFY]: 255,
    },
  },
};

export const ERRORS = {
  COMBINATIONS: {
    NO_VISIBLE: 'At least one combination must be visible',
    NO_STOCK: 'At least one combination must be in stock',
    NUMBER_EXCEEDED: {
      [ETSY]: `Should not exceed ${VALIDATIONS.COMBINATIONS.MAXIMUM_NUMBER[ETSY]} options combinations`,
      [SHOPIFY]: `Should not exceed ${VALIDATIONS.COMBINATIONS.MAXIMUM_NUMBER[SHOPIFY]} options combinations`,
    },
  },
  OPTIONS: {
    FORBIDDEN_CHARACTERS: {
      [ETSY]: 'You may not include any of these characters: ^ $ `',
    },
    NAME_EXIST: 'You may not have two options with same name',
    NAME_LENGTH_EXCEEDED: {
      [ETSY]: `Option name should not exceed ${VALIDATIONS.OPTIONS.MAXIMUM_NAME_LENGTH[ETSY]} characters`,
      [SHOPIFY]: `Option name should not exceed ${VALIDATIONS.OPTIONS.MAXIMUM_NAME_LENGTH[SHOPIFY]} characters`,
    },
    NO_OPTION: 'Fill in option',
    NO_OPTIONS: 'Add at least one option',
    NUMBER_EXCEEDED: {
      [ETSY]: `Should not exceed ${VALIDATIONS.OPTIONS.MAXIMUM_NUMBER[ETSY]} options`,
      [SHOPIFY]: `Should not exceed ${VALIDATIONS.OPTIONS.MAXIMUM_NUMBER[SHOPIFY]} options`,
    },
  },
  VARIANTS: {
    FORBIDDEN_CHARACTERS: {
      [ETSY]: 'You may not include any of these characters: ^ $ `',
      [SHOPIFY]: 'You may not include the character sequence " / "',
    },
    NAME_EXIST: 'You may not have two variants with same name',
    NAME_LENGTH_EXCEEDED: {
      [ETSY]: `Variant name should not exceed ${VALIDATIONS.VARIANTS.MAXIMUM_NAME_LENGTH[ETSY]} characters`,
      [SHOPIFY]: `Variant name should not exceed ${VALIDATIONS.VARIANTS.MAXIMUM_NAME_LENGTH[SHOPIFY]} characters`,
    },
    NAME_REQUIRED: 'Fill in variant name',
    SCALE: 'Choose scale',
  },
};

export const PLACEHOLDERS = {
  [DELETED]: 'Visibility',
  [ATTRIBUTE.BARCODE]: 'Barcode',
  [ATTRIBUTE.CAP]: 'CAP',
  [ATTRIBUTE.CHARGE_TAX]: 'Charge tax',
  [ATTRIBUTE.CONTINUE_SELLING]: 'Cont selling',
  [ATTRIBUTE.COUNTRY_CODE]: 'Country of origin',
  [ATTRIBUTE.CPI]: 'CPI',
  [ATTRIBUTE.HS_CODE]: 'HS Code',
  [ATTRIBUTE.PHYSICAL]: 'Physical',
  [ATTRIBUTE.PRICE]: 'Price',
  [ATTRIBUTE.QUANTITY]: 'Quantity',
  [ATTRIBUTE.SKU]: 'SKU',
  [ATTRIBUTE.TRACK_QUANTITY]: 'Track inv',
  [ATTRIBUTE.WEIGHT]: 'Weight',
  ADD_VARIATION: 'Add Variation',
  CHOOSE_VARIATION: 'Choose Variation',
  OPTION: 'Add option',
  SECTION: 'Choose section',
  SCALE: 'Choose Scale',
};

export const RETAIN_ATTRIBUTES = {
  [ETSY]: [
    ATTRIBUTE.PRICE,
    ATTRIBUTE.QUANTITY,
    ATTRIBUTE.SKU,
  ],
  [SHOPIFY]: [
    ATTRIBUTE.BARCODE,
    ATTRIBUTE.PRICE,
    ATTRIBUTE.QUANTITY,
    ATTRIBUTE.SKU,
    ATTRIBUTE.SHIPPING,
  ],
};

export const COMBINATION_ATTRIBUTES_TO_RETAIN = {
  [SHOPIFY]: [
    ATTRIBUTE.BARCODE,
    ATTRIBUTE.CAP,
    ATTRIBUTE.CHARGE_TAX,
    ATTRIBUTE.CONTINUE_SELLING,
    ATTRIBUTE.COUNTRY_CODE,
    ATTRIBUTE.CPI,
    'imageHash',
    'imageId',
    ATTRIBUTE.HS_CODE,
    ATTRIBUTE.PHYSICAL,
    ATTRIBUTE.PRICE,
    ATTRIBUTE.QUANTITY,
    ATTRIBUTE.TRACK_QUANTITY,
    ATTRIBUTE.SKU,
    ATTRIBUTE.UNIT,
    ATTRIBUTE.WEIGHT,
  ],
};

export const ATTRIBUTES_TO_VALIDATE = {
  [ETSY]: [
    ATTRIBUTE.PRICE,
    ATTRIBUTE.QUANTITY,
    ATTRIBUTE.SKU,
    ATTRIBUTE.VISIBILITY,
  ],
  [SHOPIFY]: [
    ATTRIBUTE.PRICE,
    ATTRIBUTE.CAP,
    ATTRIBUTE.CPI,
    ATTRIBUTE.QUANTITY,
    ATTRIBUTE.SKU,
    ATTRIBUTE.BARCODE,
    ATTRIBUTE.WEIGHT,
  ],
  [VELA]: [],
};

export const BULK_OPERATION = {
  ADD_AFTER: 'addAfter',
  ADD_BEFORE: 'addBefore',
  CHANGE_TO: 'changeTo',
  DECREASE_BY: 'decreaseBy',
  DELETE: 'delete',
  INCREASE_BY: 'increaseBy',
  SET: 'set',
};

export const BULK_OPERATION_NAME = {
  [BULK_OPERATION.ADD_AFTER]: 'Add after',
  [BULK_OPERATION.ADD_BEFORE]: 'Add before',
  [BULK_OPERATION.CHANGE_TO]: 'Change to',
  [BULK_OPERATION.DECREASE_BY]: 'Decrease by',
  [BULK_OPERATION.DELETE]: 'Delete',
  [BULK_OPERATION.INCREASE_BY]: 'Increase by',
  [BULK_OPERATION.SET]: 'Change to',
};

export const BULK_OPERATIONS = {
  [ETSY]: {
    [ATTRIBUTE.PRICE]: [
      BULK_OPERATION.INCREASE_BY,
      BULK_OPERATION.DECREASE_BY,
      BULK_OPERATION.CHANGE_TO,
    ],
    [ATTRIBUTE.QUANTITY]: [
      BULK_OPERATION.INCREASE_BY,
      BULK_OPERATION.DECREASE_BY,
      BULK_OPERATION.CHANGE_TO,
    ],
    [ATTRIBUTE.SKU]: [
      BULK_OPERATION.ADD_BEFORE,
      BULK_OPERATION.ADD_AFTER,
      BULK_OPERATION.DELETE,
      BULK_OPERATION.SET,
    ],
  },
  [SHOPIFY]: {
    [ATTRIBUTE.BARCODE]: [
      BULK_OPERATION.ADD_BEFORE,
      BULK_OPERATION.ADD_AFTER,
      BULK_OPERATION.DELETE,
      BULK_OPERATION.SET,
    ],
    [ATTRIBUTE.PRICE]: [
      BULK_OPERATION.INCREASE_BY,
      BULK_OPERATION.DECREASE_BY,
      BULK_OPERATION.CHANGE_TO,
    ],
    [ATTRIBUTE.QUANTITY]: [
      BULK_OPERATION.INCREASE_BY,
      BULK_OPERATION.DECREASE_BY,
      BULK_OPERATION.CHANGE_TO,
    ],
    [ATTRIBUTE.SKU]: [
      BULK_OPERATION.ADD_BEFORE,
      BULK_OPERATION.ADD_AFTER,
      BULK_OPERATION.DELETE,
      BULK_OPERATION.SET,
    ],
  },
  [VELA]: {
    [ATTRIBUTE.PRICE]: [
      BULK_OPERATION.INCREASE_BY,
      BULK_OPERATION.DECREASE_BY,
      BULK_OPERATION.CHANGE_TO,
    ],
    [ATTRIBUTE.QUANTITY]: [
      BULK_OPERATION.INCREASE_BY,
      BULK_OPERATION.DECREASE_BY,
      BULK_OPERATION.CHANGE_TO,
    ],
    [ATTRIBUTE.SKU]: [
      BULK_OPERATION.ADD_BEFORE,
      BULK_OPERATION.ADD_AFTER,
      BULK_OPERATION.DELETE,
      BULK_OPERATION.SET,
    ],
  },
};
